import { SET_SHOW_GEOCODE_RESULTS } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default (value) =>
    companyGeneralActions[SET_SHOW_GEOCODE_RESULTS](value);
